import { create } from "zustand";
import { RefObject } from "react";
import { PlayModes } from "../../types/PlayModes";
import { LastFmPlaylist, LastFmPlaylistItem } from "../../types/LastFmPlaylist";
import H5AudioPlayer from "react-h5-audio-player";

export interface MusicState {
    playerRef?: RefObject<H5AudioPlayer | null>
    currentTrack?: LastFmPlaylistItem;
    trackIndex: number;
    playlist: LastFmPlaylist;
    maxDuration: number;
    genreId?: number;
    genreName?: string;
    artistName?: string;
    alphaNumericGroups: string[],
    setCurrentTrack: (value: LastFmPlaylistItem) => void;
    setTrackIndex: (value: number) => void;
    setPlaylist: (value: LastFmPlaylist) => void;
    setLetters: (value: string[]) => void;
    setMaxDuration: (value: number) => void;
    setGenreId: (value: number) => void;
    setGenreName: (value: string) => void;
    setArtistName: (value: string) => void;
    erase: () => void;
    isPlaying: boolean;
    setIsPlaying: (value: boolean) => void;
    playMode: PlayModes;
    setPlayMode: (value: PlayModes) => void;
}
  
export const useMusicStore = create<MusicState>((set) => ({
    playerRef: undefined,
    currentTrack: undefined,
    trackIndex: 0,
    playlist: [],
    maxDuration: 300000,
    genreId: undefined,
    genreName: undefined,
    artistName: undefined,
    alphaNumericGroups: [],
    setCurrentTrack: (value: LastFmPlaylistItem) => set((state) => ({ currentTrack: value })),
    setTrackIndex: (value: number) => set((state) => ({ trackIndex: value })),
    setPlaylist: (value: LastFmPlaylist) => set((state) => ({ playlist: value })),
    setLetters: (value: string[]) => set((state) => ({ alphaNumericGroups: value })),
    setMaxDuration: (value: number) => set((state) => ({ maxDuration: value })),
    setGenreId: (value: number) => set((state) => ({ genreId: value })),
    setGenreName: (value: string) => set((state) => ({ genreName: value })),
    setArtistName: (value: string) => set((state) => ({ artistName: value })),
    erase: () => set((state) => ({ playlist: undefined, currentTrack: undefined, trackIndex: 0 })),
    isPlaying: false,
    setIsPlaying: (value: boolean) => set((state) => ({ isPlaying: value })),
    playMode: PlayModes.Unknown,
    setPlayMode: (value: PlayModes) => set((state) => ({ playMode: value })),
}));

export interface SearchState {
    searchText: string;
    setSearchText: (value: string) => void;
}

export const useSearchStore = create<SearchState>((set) => ({
    searchText: '',
    setSearchText: (value: string) => set((state) => ({ searchText: value })),
}));
